module.exports = function getResource(label, vars = []) {
    const resources = {
        // PayPal SDK error handling (PAY-6427)
        paymentErrorTitle: 'Erreur',
        // Shown when user cancels PayPal flow
        paymentCancellation: 'Nous n’avons pas été en mesure de passer votre commande. Problème de connexion à PayPal. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.<br /><br />S’il y a lieu, nous avons reversé tout frais en cours sur votre compte.',
        // Shown when PayPal SDK or Payment Service returns an error
        paymentErrorMessage: 'Problème de connexion à PayPal. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.',
        authorizationErrorMessage: 'We\'re sorry we cannot authorize your PayPal payment. Please select a different payment method. If applicable we have reversed any pending charges to your account.',
        okButton: 'OK'
    };

    return resources[label];
};
